<div class="box">
    
    <div *ngFor="let element of actualUnidad[0].tipo_caso">
      <div style="display: flex;">
        <p >{{ element.name}}</p>  
         <div style="margin-left: 8px;" class="inteligenciaCount" [ngStyle]="{'background':element.color}">{{element.count}}</div>
         <mat-checkbox class="example-margin"
         (change)="changeCheck(element)"
         [checked]="element.checked"
       >
        </mat-checkbox>
      </div>
       
    </div>
    <!-- <div class="inteligenciaCount" > {{inteligenciaCount}}  </div>
    <div style="text-align: center;" class="intstyle" > Suministro de Información
         <mat-checkbox class="example-margin"
      (change)="changeCheck(element.name)"
      [checked]="inteligenciaCheck"
    >
     </mat-checkbox></div> -->
</div>